import { Component, EventEmitter, Output, input, inject } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'r1-compass-lib-row-trash',
    imports: [FontAwesomeModule, MatButtonModule],
    template: `
        <div class="row-trash">
            <button
                class="trash-button"
                mat-icon-button
                (click)="onRemoveRow(index())"
                matTooltip="Remove row"
                aria-label="Remove row"
                type="button">
                <fa-icon icon="trash-alt" />
            </button>
        </div>
    `,
    styles: [
        `
            .trash-button {
                border: none;
                margin: 0 8px;
                cursor: pointer;
            }

            .trash-button:hover {
                background-color: transparent;
            }
        `,
    ],
})
export class RowTrashComponent {
    readonly #library = inject(FaIconLibrary);

    index = input.required<number>();

    @Output()
    removeRow: EventEmitter<number> = new EventEmitter<number>();

    constructor() {
        const library = this.#library;

        library.addIcons(faTrashAlt);
    }

    onRemoveRow(index: number) {
        this.removeRow.emit(index);
    }
}
